/* globals $ */
'use strict';

$(function () {
  initCarousel();

  let textSizeCanvas = document.createElement('canvas');
  let textSizeContext = textSizeCanvas.getContext('2d');
  function getTextWidth(text, font) {
    textSizeContext.font = font;
    let metrics = textSizeContext.measureText(text);
    return metrics.width;
  }
  const fontProps = [
    'font-style',
    'font-variant',
    'font-weight',
    'font-size',
    'font-family',
  ];
  $('.bus-contact .text-field').on('input', function () {
    $(this)
      .removeClass('empty not-empty')
      .addClass($(this).val() ? 'not-empty' : 'empty');
    let cs = window.getComputedStyle(this, null);
    let font = [];
    for (let fp of fontProps) {
      font.push(cs.getPropertyValue(fp));
    }
    let w = getTextWidth($(this).val(), font.join(' '));
    $(this)
      .nextAll('.text-progress:eq(0)')
      .find('span')
      .css('width', w + 'px');
  });
  $('.bus-contact .text-field').trigger('input');

  let form = $('.bus-contact form');
  form.on('submit', function (e) {
    let data = form.serializeArray();
    $.post('/foretag/kontakt', data)
      .done(function (data) {
        console.log('data /foretag/kontakt', data);
        if (data.error || data.status === 'error') {
          form.addClass('error');
          form.removeClass('submitted');
        }
      })
      .fail(function (error) {
        console.error('error post to /foretag/kontakt', error);
        form.addClass('error');
        form.removeClass('submitted');
      });
    form.addClass('submitted');
    e.preventDefault();
  });
});

function initCarousel() {
  const $testimonials = $('article.testimonials');
  const carousel = $('#testimonial-carousel');

  // Scroll-into-view animation
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');

        obs.unobserve(entry.target);
      }
    });
  });
  document.querySelectorAll('.appear-container').forEach((el) => {
    observer.observe(el);
  });

  let isMouseDown = false;
  let startX;
  let startScrollX;
  let scrollLeft;
  let lastWalk = 0;
  let scrollBlockTimeout;

  const items = $('#testimonial-carousel section');
  let offsets;
  let cardLeftOffsets;
  let targetScrollPosition;
  let halfViewWidth;
  let nextPosition;
  let farRightScrollBoundary;
  let cardWidth;
  let cardOuterPadding;

  update();

  function update() {
    cardWidth = Number(
      getComputedStyle($testimonials.get(0))
        .getPropertyValue('--testimonial-card-width')
        .replace('px', ''),
    );

    cardOuterPadding = (document.documentElement.clientWidth - cardWidth) / 2;

    carousel.css({ padding: `0px ${cardOuterPadding}px` });

    offsets = items.map(function () {
      return this.offsetLeft;
    });

    const targetScrollSensitivity = cardWidth > 600 ? 1 : 0.5;
    targetScrollPosition =
      carousel.get(0).scrollLeft - 1 * (targetScrollSensitivity * lastWalk);
    halfViewWidth = document.documentElement.clientWidth / 2;
    nextPosition = targetScrollPosition + halfViewWidth;
    cardLeftOffsets = Array.from(offsets);
    farRightScrollBoundary =
      cardLeftOffsets[cardLeftOffsets.length - 1] -
      (halfViewWidth * 2 - cardWidth - cardOuterPadding);
  }

  carousel.on('mousedown', (e) => {
    isMouseDown = true;
    carousel.addClass('active');
    carousel.css({
      transform: 'translate(0px)',
      padding: `0px ${cardOuterPadding}px`,
    });

    startX = e.clientX - carousel.get(0).offsetLeft;
    startScrollX = scrollLeft = carousel.get(0).scrollLeft;
  });

  carousel.on('mouseleave', () => {
    if (carousel.hasClass('active')) {
      handleMouseUp();
    }
  });
  carousel.on('mouseup', handleMouseUp);
  function handleMouseUp() {
    isMouseDown = false;

    clearTimeout(scrollBlockTimeout);
    carousel.addClass('scroll-block');

    update();

    const closestScrollLeft =
      findPivot(nextPosition, cardLeftOffsets) -
      (halfViewWidth - cardWidth / 2);

    const translateX = Number(carousel.css('transform').match(/\d*[.]\d*/));

    if (
      translateX === 0 &&
      Math.abs(targetScrollPosition) > 0 &&
      targetScrollPosition < farRightScrollBoundary + halfViewWidth
    ) {
      carousel.get(0).scroll({
        left: closestScrollLeft,
        behavior: 'smooth',
      });
    } else {
      carousel.css({
        transform: 'translate(0px)',
        padding: `0px ${cardOuterPadding}px`,
      });
    }

    carousel.removeClass('active');
    scrollBlockTimeout = setTimeout(
      () => carousel.removeClass('scroll-block'),
      800,
    );

    lastWalk = 0;
  }

  carousel.on('mousemove', (e) => {
    if (!isMouseDown) {
      return;
    }
    e.preventDefault();
    carousel.removeClass('scroll-block');

    // update scroll
    const x = e.pageX - carousel.get(0).offsetLeft;
    const walk = x - startX;
    carousel.get(0).scrollLeft = scrollLeft - walk;
    lastWalk = walk;

    // handle outside boundary
    update();

    if (
      carousel.get(0).scrollLeft < 1 ||
      carousel.get(0).scrollLeft > farRightScrollBoundary - 1
    ) {
      let targetOffset = -targetScrollPosition - startScrollX;
      if (carousel.get(0).scrollLeft > farRightScrollBoundary - 1) {
        targetOffset = -(startScrollX - farRightScrollBoundary - lastWalk);
      }
      const rubberMaxLength = 100;
      const rubberCoefficient = 150;
      const rubberBandPosition =
        Math.sign(targetOffset) *
        (rubberMaxLength *
          (1 - Math.exp(-Math.abs(targetOffset) / rubberCoefficient)));

      carousel.css({
        transform: `translate(${rubberBandPosition}px)`,
        padding: `0px ${cardOuterPadding}px`,
      });
    }
  });

  function findPivot(target, numbers) {
    if (numbers.length === 0) {
      return null; // or handle empty array as needed
    }

    let closest = numbers[0];
    let smallestDiff = Math.abs(target - closest);

    for (let i = 1; i < numbers.length; i++) {
      const diff = Math.abs(target - numbers[i]);
      if (diff < smallestDiff) {
        smallestDiff = diff;
        closest = numbers[i];
      }
    }

    // pivot to previous card if right card right edge is on the right side view width half
    if (target < closest) {
      closest = numbers[Math.max(numbers.indexOf(closest) - 1, 0)];
    }

    return closest;
  }
}
